/**
 * Resolve the text of a CTA whose label can be customized from the backend.
 *
 * The backend returns `null` when the editor left the field empty, but an
 * empty or blank string can also be persisted: both cases must fall back to
 * the default copy shipped with the feature app.
 */
export default function resolveCtaLabel(
    customLabel: string | null | undefined,
    defaultLabel: string
): string {
    if (typeof customLabel !== 'string' || !customLabel.trim().length) {
        return defaultLabel
    }

    return customLabel.trim()
}
